import { render, staticRenderFns } from "./AutoMessage.vue?vue&type=template&id=14d67198&scoped=true"
import script from "./AutoMessage.vue?vue&type=script&lang=js"
export * from "./AutoMessage.vue?vue&type=script&lang=js"
import style0 from "./AutoMessage.vue?vue&type=style&index=0&id=14d67198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d67198",
  null
  
)

export default component.exports